import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { isDefinedString } from "et3-type-guards";
import { fontWeights } from "et3-ui-library";
import { USER_ADVANCED_PAGE_LINK } from "../../../constants/core-constants";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../stores/core/core-personal-store";
import getKhattabat101CStore from "../../../stores/khattabat-stores/101c-stores/index";
import getKhattabatSelectsStore from "../../../stores/khattabat-stores/selects-store";
import ClientConversations from "./client-conversations";
import KhattabatClientChevron from "./KhattabatClientChevron";
import KhattabatClientSubscriptionChip from "./KhattabatClientSubscriptionChip";

const KhattabatClient = withLiteObserverAndTheme<{
  userID: number;
}>((props) => {
  const { userID } = props;
  const isMarkedConversation =
    getKhattabatSelectsStore().isMarkedConversation(userID);
  const {
    oneOTwoCounter,
    residenceCoutry,
    originCountry,
    age,
    height,
    weight,
    lastLogin,
    applicationStatus,
    marriageType,
    userName,
    isSilentBanned
  } = getKhattabat101CStore(userID);
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
  const userLink = `${USER_ADVANCED_PAGE_LINK}?id=${userID}`;

  return (
    <Stack spacing={1.5} sx={{ width: "100%", mb: 3 }}>
      <Paper
        variant="outlined"
        sx={{
          display: "flex",
          alignItems: "stretch",
          borderRadius: 3,
          borderColor: isMarkedConversation ? "success.main" : "divider"
        }}
      >
        <Checkbox
          color="success"
          checked={isMarkedConversation}
          onChange={() =>
            getKhattabatSelectsStore().toggleMarkConversation({ userID })
          }
          slotProps={{ input: { "aria-label": userName.get() } }}
          sx={{ alignSelf: "center", ml: 0.5 }}
        />
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          useFlexGap
          sx={{ flex: 1, minWidth: 0, p: 1.5 }}
        >
          <Link
            href={userLink}
            target="_blank"
            underline="hover"
            fontWeight={fontWeights.semibold}
          >
            {userName.get()}
          </Link>
          {isSilentBanned.get() === 1 ? (
            <Chip
              size="small"
              color="error"
              label={i18n.get("SILENT_BAN_ABBREVIATION")}
            />
          ) : null}
          <Link
            href={userLink}
            target="_blank"
            underline="hover"
            color="text.secondary"
          >
            {userID}
          </Link>
          {isAiKhattaba ? null : (
            <KhattabatClientSubscriptionChip userID={userID} />
          )}
          {isAiKhattaba ? null : (
            <Chip
              size="small"
              variant="outlined"
              label={`${i18n.get("KHATTABAT_CLIENT_102_COUNTER")}: ${oneOTwoCounter.get()}`}
            />
          )}
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("KHATTABAT_CLIENT_LOCATION")}: ${residenceCoutry.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("NATIONALITY")}: ${originCountry.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("AGE")}: ${age.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("HEIGHT")}: ${height.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("WEIGHT")}: ${weight.get()}`}
          />
          <Chip
            size="small"
            variant="outlined"
            label={`${i18n.get("LAST_LOGIN")}: ${lastLogin.get()}`}
          />
          {isAiKhattaba ? (
            <Chip
              size="small"
              variant="outlined"
              label={`${i18n.get("STATUS")}: ${applicationStatus.get()}`}
            />
          ) : null}
          {isDefinedString(marriageType.get()) ? (
            <Chip size="small" variant="outlined" label={marriageType.get()} />
          ) : null}
        </Stack>
        <KhattabatClientChevron userID={userID} />
      </Paper>
      <ClientConversations clientID={userID} />
    </Stack>
  );
});

export default KhattabatClient;
